const TS_EXT = /\.(m2ts|mts|ts)(?:$|\?|#)/i;
const TS_MIME = /^video\/(?:mp2t|mp2ts|m2ts|x-m2ts)$/i;
const UNSUPPORTED_EXT = /\.(mpg|mpeg|vob|wmv|asf|avi|flv|3gp|3g2|rm|rmvb)(?:$|\?|#)/i;
const MP4_EXT = /\.(mp4|m4v|mov)(?:$|\?|#)/i;
const MP4_MIME = /^video\/(?:mp4|quicktime|x-m4v)$/i;

export function isMpegTs(url, probe) {
  if (probe?.contentType && TS_MIME.test(probe.contentType)) return true;
  return typeof url === 'string' && TS_EXT.test(url);
}

export function looksLikeMp4(url, probe) {
  if (probe?.contentType && MP4_MIME.test(probe.contentType)) return true;
  return typeof url === 'string' && MP4_EXT.test(url);
}

export function classifyFormat(url, probe) {
  if (!url) return { kind: 'unknown', message: '', tone: 'neutral' };
  if (isMpegTs(url, probe)) {
    if (probe && !probe.available) {
      return { kind: 'mpegts-blocked', message: 'MPEG-TS source — CORS-blocked probe.', tone: 'warn' };
    }
    return { kind: 'mpegts', message: 'MPEG-TS stream — using mpegts.js.', tone: 'ok' };
  }
  if (UNSUPPORTED_EXT.test(url)) {
    return {
      kind: 'unsupported',
      message: 'Format not playable in-browser — re-encode source as H.264/AAC MP4.',
      tone: 'warn',
    };
  }
  if (/\.mkv(?:$|\?|#)/i.test(url)) return { kind: 'mkv', message: 'MKV container.', tone: 'neutral' };
  if (/\.webm(?:$|\?|#)/i.test(url)) return { kind: 'webm', message: 'WebM.', tone: 'ok' };
  return { kind: 'mp4', message: '', tone: 'neutral' };
}
